import { useState } from "react";
import { toast } from "sonner";
import { Radar, Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F9] av-grid-bg px-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border-2 border-obsidian p-8 shadow-[8px_8px_0px_0px_rgba(10,10,10,1)]" data-testid="admin-login-form">
        <div className="flex items-center gap-2 mb-1">
          <div className="bg-obsidian text-white h-9 w-9 flex items-center justify-center">
            <Radar className="h-5 w-5 text-conversion" />
          </div>
          <span className="font-heading font-bold text-xl text-obsidian">AI<span className="text-conversion">Visible</span></span>
        </div>
        <h1 className="font-heading text-2xl font-bold text-obsidian mt-4 flex items-center gap-2">
          <Lock className="h-5 w-5 text-conversion" /> Admin Login
        </h1>
        <p className="text-sm text-neutral-500 mt-1 mb-6">Access the lead CRM &amp; funnel analytics.</p>

        <label className="av-label">Email</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="av-input mt-1 mb-4" placeholder="admin@dev4u.ai" data-testid="admin-email" required />

        <label className="av-label">Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="av-input mt-1 mb-6" placeholder="••••••••" data-testid="admin-password" required />

        <button type="submit" disabled={loading} className="av-btn w-full" data-testid="admin-login-submit">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign In"}
        </button>
      </form>
    </div>
  );
}
